<template>
  <div>
      <v-autocomplete
              v-model="input"
              :items="siteTypes"
              class="m-1"
              dense
              v-if="others"
              :rules="rules"
              item-text="keyAlias"
              item-value="key"
              :error-messages="errors !== undefined ? errors : []"
              label="نوع زبان برنامه نویسی  را انتخاب فرمایید."
              outlined
              :return-object="return_object"
      >
          <template v-slot:prepend-item>
              <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="others = false"
              ><v-list-item-action>
                      <p>واردکردن زبان های دیگر</p>
                  </v-list-item-action>
              </v-list-item>
          </template>
      </v-autocomplete>
      <v-text-field
              v-if="!others"
              label="نوع زبان برنامه نویسی"
              dense
              v-model="input"
              :rules="rules"
              outlined
              prepend-inner-icon="fa fa-pencil-alt"
              clear-icon="mdi-close-circle-outline"
              clearable
              @click:clear="others=true"
      ></v-text-field>
  </div>
</template>

<script>

export default {
    props: ['value', 'errors', 'dense', 'return_object'],

    data() {
        return {
            input: this.null,
            others: true,
            rules: [
                (value) => !!value || "وارد کردن این فیلد الزامی است.",
            ],
            siteTypes: [
                {key: 'wordPress', keyAlias: 'وردپرس/wordPress'},
                {key: 'php', keyAlias: 'php/پی اچ پی'},
                {key: '.net', keyAlias: '.NET/دات نت'},
                {key: 'python', keyAlias: 'python/پایتون'},
                {key: 'javaScript', keyAlias: 'javaScript/جاوااسکریپت'},
                {key: 'laravel', keyAlias: 'laravel/لاراول'},
                {key: 'golang', keyAlias: 'javaScript/گولنگ'},
                {key: 'joomla', keyAlias: 'joomla/جوملا'},
            ],

        }
    },
    name: "siteSelect",
    created() {
        this.input = this.value
    },
    watch: {
        input() {
            this.$emit('input', this.input)
        }
    }
}
</script>

<style scoped>

</style>